(function () {
  function setupCustomSliderScrollbar(component) {
    if (!component || component.dataset.customScrollbarReady === 'true') return;

    const slider = component.querySelector('.slider');
    const track = component.querySelector('.custom-slider-scrollbar__track');
    const thumb = component.querySelector('.custom-slider-scrollbar__thumb');

    if (!slider || !track || !thumb) return;

    let isDragging = false;

    function getMaxScroll() {
      return Math.max(slider.scrollWidth - slider.clientWidth, 0);
    }

    function getThumbWidth() {
      return thumb.offsetWidth;
    }

    function getTrackWidth() {
      return track.offsetWidth;
    }

    function getMaxThumbX() {
      return Math.max(getTrackWidth() - getThumbWidth(), 0);
    }

    function updateThumb() {
      const maxScroll = getMaxScroll();
      const maxThumbX = getMaxThumbX();

      if (maxScroll <= 0 || maxThumbX <= 0) {
        thumb.style.transform = 'translateY(-50%) translateX(0px)';
        return;
      }

      const progress = slider.scrollLeft / maxScroll;
      const thumbX = progress * maxThumbX;

      thumb.style.transform = `translateY(-50%) translateX(${thumbX}px)`;
    }

    function setScrollFromPointer(clientX) {
      const trackRect = track.getBoundingClientRect();
      const thumbWidth = getThumbWidth();
      const maxThumbX = getMaxThumbX();
      const maxScroll = getMaxScroll();

      if (maxScroll <= 0 || maxThumbX <= 0) return;

      let x = clientX - trackRect.left - thumbWidth / 2;
      x = Math.max(0, Math.min(x, maxThumbX));

      const progress = x / maxThumbX;
      slider.scrollLeft = progress * maxScroll;
    }

    function onPointerDown(event) {
      isDragging = true;
      thumb.style.cursor = 'grabbing';
      setScrollFromPointer(event.clientX);
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isDragging) return;
      setScrollFromPointer(event.clientX);
    }

    function onPointerUp() {
      isDragging = false;
      thumb.style.cursor = 'grab';
    }

    slider.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);

    thumb.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointerdown', onPointerDown);

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);

    updateThumb();

    component.dataset.customScrollbarReady = 'true';
  }

  function initAllCustomSliders(root = document) {
    const components = root.querySelectorAll('slider-component.custom-product-scroll');
    components.forEach(setupCustomSliderScrollbar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllCustomSliders();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllCustomSliders(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAllCustomSliders();
  });
})();